// extracted by mini-css-extract-plugin
module.exports = {"lead":"LeadText_lead__rfwFU"};